export default __webpack_public_path__ + "static/media/p19.4ed5f314.jpeg";